import { combineReducers } from '@reduxjs/toolkit';
import { StateType } from 'typesafe-actions';

import chat from './chat/reducer';
import dataExplorer from './data-explorer/reducer';
import entityHierarchies from './entity-hierarchies/reducer';
import organization from './organization/reducer';
import resourceLists from './resource-lists/reducer';
import resources from './resources/reducer';
import router from './router/reducer';
import sessionError from './session/error-reducer';
import session from './session/reducer';
import * as sessionTypes from './session/types';
import surveys from './surveys/reducer';
import toasts from './toasts/reducer';
import userSettings from './user-settings/reducer';

const createRootReducer = () => (prevState: any, action: any) => {
    const reducer = combineReducers({
        router,
        session,
        sessionError,
        organization,
        userSettings,
        dataExplorer,
        entityHierarchies,
        resourceLists,
        resources,
        surveys,
        chat,
        toasts,
    });

    switch (action.type) {
        // clean root state on sign out
        case sessionTypes.SESSION_SIGNED_OUT:
            return reducer({}, action);

        default:
            return reducer(prevState, action);
    }
};

export default createRootReducer;

export type RootState = StateType<ReturnType<typeof createRootReducer>>;
